/**
 * Quotify Pre-Modal
 *
 * The HTML is server-rendered by sections/quotify-pre-modal.liquid.
 * This script only handles show/hide and listens for the postMessage
 * sent by the Quotify iframe via the custom JS bridge.
 *
 * Triggered by: quotify_product_added (relayed via postMessage from iframe)
 * "Weiter" / close → dismiss modal, Quotify popup remains visible underneath
 * "Zubehör ansehen" → navigates to accessories collection (product already in quote)
 *
 * Tag filter: data-required-tags on the backdrop element (comma-separated).
 * If set, the modal only opens when the clicked product has at least one matching tag.
 */
(function () {
  const backdrop = document.getElementById('quotify-pre-modal-backdrop');
  if (!backdrop) return;

  /* ── Tag filter ───────────────────────────────────────────────────────── */

  const requiredTagsRaw = (backdrop.dataset.requiredTags || '').trim();
  const requiredTags = requiredTagsRaw
    ? requiredTagsRaw.split(',').map((t) => t.trim().toLowerCase()).filter(Boolean)
    : [];

  // Track the product tags of the last clicked [data-quotify] button
  let pendingProductTags = [];

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quotify]');
    if (!btn) return;
    try {
      const product = JSON.parse(btn.dataset.product || '{}');
      pendingProductTags = (product.tags || []).map((t) => t.toLowerCase());
    } catch {
      pendingProductTags = [];
    }
  }, { capture: true, passive: true });

  function productMatchesFilter() {
    if (requiredTags.length === 0) return true; // no filter → always show
    return requiredTags.some((tag) => pendingProductTags.includes(tag));
  }

  /* ── Visibility ───────────────────────────────────────────────────────── */

  function showModal() {
    backdrop.classList.remove('is-hidden');
    backdrop.getBoundingClientRect(); // force reflow before transition
    backdrop.classList.add('is-visible');

    const modal = document.getElementById('quotify-pre-modal');
    if (modal) modal.focus();
  }

  function hideModal() {
    backdrop.classList.remove('is-visible');
    backdrop.addEventListener(
      'transitionend',
      () => backdrop.classList.add('is-hidden'),
      { once: true }
    );
  }

  /* ── Event listeners ──────────────────────────────────────────────────── */

  document.getElementById('quotify-pre-modal-close')
    ?.addEventListener('click', hideModal);

  document.getElementById('quotify-pre-modal-continue')
    ?.addEventListener('click', hideModal);

  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) hideModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !backdrop.classList.contains('is-hidden')) {
      hideModal();
    }
  });

  /* ── postMessage bridge ───────────────────────────────────────────────── */

  window.addEventListener('message', (event) => {
    if (event.data?.action !== 'quotify_tracking') return;
    if (event.data?.event_name !== 'quotify_product_added') return;
    if (!productMatchesFilter()) return;
    showModal();
  });
})();
